const api = (await import("../../../services/axiosConfig")).default;

export const MODULE_INSTANCE_CONFIG = {
  Hadoop: {
    url: "big-data/hdfs",
    containerFilter: "namenode",
    httpMethod: "post",
    startMsg: "HDFS Cluster Started",
    stopMsg: "HDFS Cluster Stopped",
    destroyMsg: "HDFS Cluster Destroyed",
    destroyEndpoint: "destroy",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  Spark: {
    url: "big-data/spark",
    containerFilter: "master",
    httpMethod: "post",
    startMsg: "Spark Cluster Started",
    stopMsg: "Spark Cluster Stopped",
    destroyMsg: "Spark Cluster Destroyed",
    destroyEndpoint: "destroy",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  Hive: {
    url: "big-data/hive",
    containerFilter: "server",
    httpMethod: "post",
    startMsg: "Hive Cluster Started",
    stopMsg: "Hive Cluster Stopped",
    destroyMsg: "Hive Cluster Destroyed",
    destroyEndpoint: "destroy",
    dependencies: ["Hadoop"],
    statusOnStop: "STOPPED",
  },
  "SKEYE NOTE": {
    url: "skeye/skeyenote",
    containerFilter: "skeyenote",
    httpMethod: "post",
    startMsg: "SKEYE NOTE Started",
    stopMsg: "SKEYE NOTE Stopped",
    destroyMsg: "SKEYE NOTE Deleted",
    destroyEndpoint: "destroy",
    destroyMethod: "delete",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  "SKEYE CHARTS": {
    url: "skeye/skeyechart",
    containerFilter: "skeyechart",
    httpMethod: "post",
    startMsg: "SKEYE CHARTS Started",
    stopMsg: "SKEYE CHARTS Stopped",
    destroyMsg: "SKEYE CHARTS Deleted",
    destroyEndpoint: "destroy",
    destroyMethod: "delete",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  "SKEYE CUBE": {
    url: "skeye/skeyecube",
    containerFilter: "server",
    httpMethod: "post",
    startMsg: "SKEYE CUBE Started",
    stopMsg: "SKEYE CUBE Stopped",
    destroyMsg: "SKEYE CUBE Deleted",
    destroyEndpoint: "destroy",
    destroyMethod: "delete",
    dependencies: ["Hadoop", "Hive", "Spark"],
    statusOnStop: "STOPPED",
  },
  "SKEYE PREDICT": {
    url: "skeye/skeyepredict",
    containerFilter: "server",
    httpMethod: "post",
    startMsg: "SKEYE PREDICT Started",
    stopMsg: "SKEYE PREDICT Stopped",
    destroyMsg: "SKEYE PREDICT Deleted",
    destroyEndpoint: "destroy",
    destroyMethod: "delete",
    dependencies: ["Hadoop"],
    statusOnStop: "STOPPED",
  },
  "SKEYE INGEST": {
    url: "skeye/skeyeingest",
    containerFilter: "skeyeingest",
    httpMethod: "post",
    startMsg: "SKEYE INGEST Started",
    stopMsg: "SKEYE INGEST Stopped",
    destroyMsg: "SKEYE INGEST Deleted",
    destroyEndpoint: "destroy",
    destroyMethod: "delete",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  "SKEYE FORM": {
    url: "skeye/skeyeform",
    containerFilter: "skeyeform",
    httpMethod: "post",
    startMsg: "SKEYEFORM Started",
    stopMsg: "SKEYEFORM Stopped",
    destroyMsg: "SKEYEFORM Deleted",
    destroyEndpoint: "destroy",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  "DG Helper": {
    url: "governeye/dghelper",
    containerFilter: "dghelper",
    httpMethod: "post",
    startMsg: "DG HELPER Started",
    stopMsg: "DG HELPER Stopped",
    destroyMsg: "DG Helper Deleted",
    destroyEndpoint: "destroy",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  Fahras: {
    url: "governeye/fahras",
    containerFilter: "fahras",
    httpMethod: "post",
    startMsg: "Fahras Started",
    stopMsg: "Fahras Stopped",
    destroyMsg: "Fahras Deleted",
    destroyEndpoint: "destroy",
    dependencies: [],
    statusOnStop: "STOPPED",
  },
  Jeyeda: {
    url: "governeye/jeyeda",
    containerFilter: "jeyeda",
    httpMethod: "post",
    startMsg: "Jeyeda Started",
    stopMsg: "Jeyeda Stopped",
    destroyMsg: "Jeyeda Deleted",
    destroyEndpoint: "destroy",
    dependencies: ["Hadoop", "SKEYE INGEST"],
    statusOnStop: "STOPPED",
  },
};

export function checkDependencies(title, cardStatus, toast) {
  const config = MODULE_INSTANCE_CONFIG[title];
  if (!config?.dependencies?.length) return true;
  for (const dep of config.dependencies) {
    if (cardStatus[dep] !== "RUNNING") {
      toast.current?.show({
        severity: "info",
        summary: "Info",
        detail: `${dep} instance must be running to start ${title}`,
      });
      return false;
    }
  }
  return true;
}
